(function () {
	'use strict';
	$(document).ready(function () {

		// Smooth scroll to
		$('.scroll-animation').on('click', function (e) {
			e.preventDefault();

			const href = $(this).attr('href');
			if (href) {
				$("html, body").animate({
					scrollTop: $(href).offset().top
				}, 1000);
			}
		});

		$('.scroll-animation a').on('click', function (e) {
			e.stopPropagation();
		});

		//Search trigger
		$('.search-trigger').click(function () {
			$(this).toggleClass('active');
			$('.search-panel').fadeToggle('active');
			return false;
		});

		const isOverflowing = (element, container = document.body) => {
			const containerRect = container.getBoundingClientRect();
			const containerTop = containerRect.top + window.scrollY;
			const elementRect = element.getBoundingClientRect();
			const elementTop = elementRect.top + window.scrollY;

			if (containerTop + containerRect.height < elementTop + elementRect.height) {
				return 'bottom'
			}

			if (containerTop > elementTop || elementRect.y <= 0) {
				return 'top';
			}

			return null;
		}


		if ($("a.show-gallery").length) {
			$("a.show-gallery").fancybox({
				speedIn: 900,
				speedOut: 900,
				changeFade: "slow"
			});
		}
	});
}(jQuery));
